<script setup lang="ts">
import { ConfigProvider } from "reka-ui";
import "@/css/_main.css";
</script>

<template>
  <ConfigProvider>
    <slot />
    <UiToaster />
  </ConfigProvider>
</template>
